import React from "react";

const GOLD = "#E2DD9F";

export default function ComingSoonScreen({ name, blurb, eta, dark = true, C, onBack }) {
  const text = dark ? "#F5F5F5" : "#111";
  const textDim = dark ? "rgba(255,255,255,0.55)" : "rgba(0,0,0,0.55)";
  const bg = dark ? "#0A0A0A" : "#FAFAFA";
  const border = C?.border || (dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)");

  return (
    <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",
      flexDirection:"column",padding:40,textAlign:"center",background:bg,minHeight:"60vh"}}>
      <div style={{width:80,height:80,borderRadius:20,background:`${GOLD}15`,
        display:"flex",alignItems:"center",justifyContent:"center",marginBottom:24,
        border:`1px solid ${GOLD}40`}}>
        <div style={{fontSize:36}}>🔒</div>
      </div>
      <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:11,color:GOLD,
        letterSpacing:3,marginBottom:8}}>COMING SOON</div>
      <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:42,color:text,
        letterSpacing:2,lineHeight:1.05,marginBottom:14}}>{name}</div>
      {blurb && (
        <div style={{fontSize:14,color:textDim,maxWidth:420,lineHeight:1.6,marginBottom:18}}>
          {blurb}
        </div>
      )}
      {eta && (
        <div style={{fontSize:12,fontWeight:700,color:GOLD,letterSpacing:1.4,
          padding:"6px 14px",borderRadius:20,border:`1px solid ${GOLD}55`,
          background:`${GOLD}10`,marginBottom:24}}>
          {eta}
        </div>
      )}
      {onBack && (
        <button onClick={onBack}
          style={{padding:"10px 28px",borderRadius:8,fontSize:13,fontWeight:800,
            background:GOLD,color:"#111",border:"none",cursor:"pointer",
            fontFamily:"'Bebas Neue',sans-serif",letterSpacing:1.4}}>
          Back to Dashboard
        </button>
      )}
    </div>
  );
}
